import React from 'react';

const HomeSingleTeam = ({ image, title, subtitle, postition }) => {
   return (
      <>
         <div className="col-xl-4 col-lg-4 col-md-6">
            <div className="team-box text-center mb-60">
               <div className="team-thumb mb-45 pos-rel">
                  <img src={`img/doctor/${image}.jpg`} alt="" />
                  {/* <Link className="team-link" to="/doctorDetails">+</Link> */}
               </div>
               <div className="team-content">
                  <h3>{title}</h3>
                  <h6>{subtitle}</h6>
                  <h5>{postition}</h5>
               </div>
            </div>
         </div>
      </>
   );
};

export default HomeSingleTeam;